const toolsGtm = {
    gtmBuyOneClick: function (gtmInfo, orderId) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "purchase",
            ecommerce: {
                transaction_id: orderId,
                affiliation: "by_one_click",
                value: gtmInfo.length > 0 ? Number(gtmInfo[0].price) * Number(gtmInfo[0].quantity) : 0,
                currency: "EUR",
                items: gtmInfo
            }
        });
    },

    gtmCheckout: function (gtmInfo, orderInfo) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "purchase",
            ecommerce: {
                transaction_id: orderInfo.order_id,
                affiliation: "main",
                value: orderInfo.price,
                currency: "EUR",
                shipping_tier: orderInfo.type_delivery,
                payment_method: orderInfo.type_payment,
                items: gtmInfo,
            }
        });
    },

    gtmAddToCart: function (gtmInfo, label = 'main') {
        if (gtmInfo.length > 0) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "add_to_cart",
                label: label,
                ecommerce: {
                    items: gtmInfo
                }
            });
        }
    },

    gtmAddPaymentInfo(gtmInfo, typePayment, orderInfo) {
        if (gtmInfo.length > 0) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "add_payment_info",
                ecommerce: {
                    currency: "EUR",
                    value: orderInfo.price,
                    payment_type: typePayment,
                    items: gtmInfo,
                }
            });
        }
    },

    gtmAddShippingInfo(gtmInfo, typeDelivery, orderInfo) {
        if (gtmInfo.length > 0) {
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "add_shipping_info",
                ecommerce: {
                    currency: "EUR",
                    value: orderInfo.price,
                    shipping_tier: typeDelivery,
                    items: gtmInfo,
                }
            });
        }
    },

    gtmAddToWaitlist: function (id) {
        dataLayer.push({
            ecommerce: null
        });
        dataLayer.push({
            'event': 'add_to_waitlist',
            'item_id': id
        });
    },

    gtmRegister: function () {
        dataLayer.push({
            ecommerce: null
        });
        dataLayer.push({
            'event': 'sign_up'
        });
    }
};

window.toolsGtm = toolsGtm;